// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"YtVideo_playerWrapper__4gjbo","detail":"YtVideo_detail__JEIz3","reactPlayer":"YtVideo_reactPlayer__Gwb-A"};